import { h } from "@stencil/core";

export const RenderTableOfContentsStep = (
    step,
    data,
    baseClass,
    handleTableOfContentsClick
) => {
    const steps = data?.steps.filter((s) => s.type === "content") || [];
    const middleIndex = Math.ceil(steps.length / 2);
    const leftSteps = steps.slice(0, middleIndex);
    const rightSteps = steps.slice(middleIndex);

    const renderSteps = (stepsArray, globalIndexStart) => (
        <div class={`${baseClass}__table-of-contents`}>
            {stepsArray.map((step, localIndex) => {
                const globalIndex = globalIndexStart + localIndex + 1;
                return (
                    <div
                        class={`${baseClass}__table-of-contents-link`}
                        key={globalIndex}
                        onClick={() =>
                            handleTableOfContentsClick(globalIndex + 1)
                        }
                    >
                        <div class={`${baseClass}__table-of-contents-text`}>
                            <span
                                class={`${baseClass}__table-of-contents-link-number ux-text-title ux-text-title--big ux-text-title--bold`}
                            >
                                {String(globalIndex).padStart(2, "0")}
                            </span>{" "}
                            <span class="ux-text-normal">{step.headline}</span>
                        </div>
                        <ux-icon name="arrow-right" weight="normal"></ux-icon>
                    </div>
                );
            })}
        </div>
    );

    return (
        <div>
            <div class={`${baseClass}__content`}>
                <div class={`${baseClass}__text`}>
                    {step?.headline && (
                        <div class="ux-text-headline ux-text-headline--giant ux-u-mb-xxxs">
                            {step.headline}
                        </div>
                    )}
                    {step?.text && <div innerHTML={step.text}></div>}
                </div>
            </div>
            <div class={`${baseClass}__table-of-contents-wrapper`}>
                <div class={`${baseClass}__table-of-contents-left`}>
                    {renderSteps(leftSteps, 0)}
                </div>
                <div class={`${baseClass}__table-of-contents-right`}>
                    {renderSteps(rightSteps, middleIndex)}
                </div>
            </div>
        </div>
    );
};
